export default {
  confirmationContainer: {
    '& p': {
      marginBottom: '10px',
    },
    '& li p': {
      marginBottom: '0',
    },
    '& a': {
      color: 'inherit',
    },
  },
  confirmationButtonContainer: {},
  confirmationTitle: {
    fontWeight: 'bold',
  },
  confirmationList: {},
  confirmationItemLabel: {
    fontStyle: 'italic',
  },
};
